import React, { Component} from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link, IndexLink } from 'react-router';

import { downloadSpeakers } from './actions';
import './style.css';


class Speakers extends Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    this.props.downloadSpeakers();
    window.scrollTo(0, 0);
  }

  render() {
    const baseUrl = '/speakers';
    const links = this.props.sections.map(section => (
      <Link
        key={section.id} to={baseUrl + '/' + section.id}
        className={'speaker__tabs-item speaker__tabs-item-' + section.id}
        activeClassName={'speaker__tabs-item_' + section.id}
      >
        {section.name}
      </Link>
    ));
    return (
      <div className='speakers'>
        <div className='speakers__title'>Докладчики</div>
        <div className='speakers__container'>
          <div className='speaker__tabs'>
            <IndexLink
              to={baseUrl}
              className='speaker__tabs-item speaker__tabs-item-all'
              activeClassName='speaker__tabs-item_all'
            >
              все
            </IndexLink>
            {links}
          </div>
          {this.props.children}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  sections: state.speakers.sections
});

const mapDispatchToProps = (dispatch) => ({
  downloadSpeakers: bindActionCreators(downloadSpeakers, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps, null, {pure: false})(Speakers);



// WEBPACK FOOTER //
// ./src/speakers-page/Speakers.js